import withErrorCheck from "../CheckError";
import server from "../Server";
import type { ISeason } from "@grassrootly/api/entities";

export interface GetCompetitionSeasonsPayload {
  competitionId: number;
}

export interface GetCompetitionSeasonsResponse {
  seasons: ISeason[];
  defaultSeasonId: number | null;
}

// Fetch all seasons for a competition
export const GetCompetitionSeasons = async ({
  competitionId,
}: GetCompetitionSeasonsPayload): Promise<GetCompetitionSeasonsResponse> => {
  const response = await server
    .from("Seasons")
    .select("*")
    .eq("competition_id", competitionId)
    .order("created_at", { ascending: false });

  const seasons = withErrorCheck<ISeason[]>(response as any) || [];

  // Determine default season: most recent active season, or most recent season
  let defaultSeasonId: number | null = null;
  
  if (seasons.length > 0) {
    const activeSeason = seasons.find((s) => s.is_active);
    defaultSeasonId = activeSeason ? activeSeason.id : seasons[0].id;
  }

  return {
    seasons,
    defaultSeasonId,
  };
};
